import { PropsWithChildren } from "react";
import { MessagesContainerStyled } from "../styles";

type Props = PropsWithChildren<{
  disablePadding?: boolean;
}>;

const MessagesContainer = ({ children, disablePadding }: Props) => (
  <MessagesContainerStyled item disablePadding={disablePadding}>
    {children}
  </MessagesContainerStyled>
);

export default MessagesContainer;
